export default "__VITE_ASSET__D0RaNX31__$_?nuxt_component=async&nuxt_component_name=IconFielmannLogoPL&nuxt_component_export=default__"